import { Button } from "ui";
import Icon from "components/icon";
import { Link } from "react-router-dom";
import { PLUS } from "icons";
import React from "react";
import classNames from "classnames";

const CreateItemButton = ({ children, href, disabled = false, ...props }) => {

  if (href) {
    return (
      <Link
        to={href?.length ? href : "+"}
        className={classNames({ "pointer-events-none": disabled })}
      >
        <Button {...props} disabled={disabled} className="flex items-center">
          <Icon icon={PLUS} /> {children}
        </Button>
      </Link>
    );
  }
  return (
    <Button {...props} disabled={disabled} className="flex items-center">
      <Icon icon={PLUS} /> {children}
    </Button>
  );
};

export default CreateItemButton;
